import React from 'react'
// ##
import BuyerCategoriesTable from '../../modules/BuyerCategory/components/BuyerCategoriesTable'

export default function BuyerCategoryPage() {
  return <BuyerCategoriesTable />
}
